export type Faq = {
  question: string;
  answer: string;
};

export const generalFaqs: Faq[] = [
  {
    question: "什么样的线索适合投稿？",
    answer:
      "只要是你亲身经历、亲眼所见，或能提供可核实材料的事情，都值得一试。有明确的时间、地点、当事人和证据链，会比只有情绪和转述的线索更容易被编辑跟进。",
  },
  {
    question: "没有一手材料，只有听说，能不能投？",
    answer:
      "可以先投，但请如实说明信息来源与确认程度。编辑会把「有待核实」的线索单独归类，如果你能提供进一步的联系人渠道，被跟进的可能性会明显提高。",
  },
  {
    question: "投稿之后多久会有回复？",
    answer:
      "工作日 24 小时内给出初审答复。需要补充材料或深入采访的选题，编辑会主动联系你，说明下一步需要配合的内容。",
  },
  {
    question: "投稿会不会泄露我的身份？",
    answer:
      "投稿信息全程加密保存，只有对接编辑可见。你可以选择匿名或使用化名，涉及敏感内容时，编辑会先与你确认保护方案再决定是否推进。",
  },
  {
    question: "一次可以投几条选题？",
    answer:
      "建议一次集中投一条，把材料写完整。确有多个独立选题时，可以在表单里分别说明，编辑会分别评估。",
  },
  {
    question: "稿件被采用后有稿酬吗？",
    answer:
      "会采用并有明确稿酬标准。金额与线索价值、材料完整度和后续跟进工作量有关，编辑在确认采用时会提前与你沟通，不会事后压价。",
  },
  {
    question: "可以投已经发过的内容吗？",
    answer:
      "可以，但要说明首发平台与时间。编辑更看重你有没有别人没有的新角度、新证据或新进展，二手转载很难被采用。",
  },
  {
    question: "图片、视频等材料怎么提供？",
    answer:
      "在投稿表单里说明材料类型与数量即可，编辑会通过安全渠道与你对接。请勿在公开评论区或社交平台直接发布原始材料。",
  },
];